// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"29d4a990","232":"fd09ff22","310":"be54d64e","831":"448839e4","927":"be10e363","940":"92281fc2","992":"a2034f04"}[chunkId] + ".js";
};